// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 23) return "./default/chunk-html-box-reg-wall.e863c17eab9a33da6f9e.js";
	if (chunkId === 33) return "./default/chunk-recombee-init.197b954017bcacd6da60.js";
	if (chunkId === 24) return "./default/chunk-lazyload-images.b17e77a55d7416395fff.js";
	if (chunkId === 21) return "./default/chunk-gtm-highlight.971156f0b6fb42e7ba91.js";
	if (chunkId === 31) return "./default/chunk-progressBar.9713b6c3b815f6f21673.js";
	if (chunkId === 13) return "./default/chunk-accordion.8c2304b59ee06d858531.js";
	if (chunkId === 18) return "./default/chunk-fadeInOnEnterViewport.7ff549bf37f0f0f072ce.js";
	if (chunkId === 27) return "./default/chunk-megamenu.fab46dbace07bdb7be38.js";
	if (chunkId === 22) return "./default/chunk-header.ff7ddb612ef39d3f3359.js";
	if (chunkId === 26) return "./default/chunk-mainNavigation.92d5c8ff5114822c3d32.js";
	if (chunkId === 28) return "./default/chunk-modal.22dc43db053ab1b1a673.js";
	if (chunkId === 64) return "./64.c251317e239a97eed7df.js";
	if (chunkId === 20) return "./default/chunk-gallery.3b81ace903fa007cc2f6.js";
	if (chunkId === 17) return "./default/chunk-enquiry.3afa934e362f663ebcde.js";
	if (chunkId === 37) return "./default/chunk-survey.38cb2577facb10011469.js";
	if (chunkId === 19) return "./default/chunk-forum.20bf9164f2c75683e6cf.js";
	if (chunkId === 60) return "./60.bd88f5c32c0c13b5ed47.js";
	if (chunkId === 32) return "./default/chunk-recombee.773838cb742089f4b3eb.js";
	if (chunkId === 61) return "./61.fce744385c7bc42b5295.js";
	if (chunkId === 25) return "./default/chunk-load-more.58268a86cff256e1a3b3.js";
	if (chunkId === 39) return "./default/chunk-uncover-behav-articles.0b76f9286fff2a0dd163.js";
	if (chunkId === 14) return "./default/chunk-ads-repeater.f0e11450847661cdf6cb.js";
	if (chunkId === 46) return "./default/newsletter.c2087c3ec0f02d32e6eb.js";
	if (chunkId === 41) return "./default/companySubscription.e571d1dec4d732f275a7.js";
	if (chunkId === 49) return "./default/swiper.45dbd5237b7e9034f501.js";
	if (chunkId === 51) return "./default/thingsArticleSwiper.59743b8cf0defc5aaf75.js";
	if (chunkId === 16) return "./default/chunk-editorial-promo.0846effdb05ed0d07e11.js";
	if (chunkId === 52) return "./default/topic-banner.e52951d1cf868bec1e0d.js";
	if (chunkId === 44) return "./default/instagram.6eb5d88fcfd8ffdbd3ec.js";
	if (chunkId === 47) return "./default/piano.22b83c91c7e0c2087bc0.js";
	if (chunkId === 62) return "./62.0d9502e296f85cc8f2a1.js";
	if (chunkId === 48) return "./default/portaInit.2182a23d3dcd8f1be028.js";
	if (chunkId === 45) return "./default/jakebox.b0282886fed57702278f.js";
	if (chunkId === 40) return "./default/collapser.542787a3e430c1d99cda.js";
	if (chunkId === 12) return "./default/author-card-list.c5f23fdca1b02ec61c4b.js";
	if (chunkId === 11) return "./chunk-todayResultSliderHP.0074b0b6d8ddbef9363c.js";
	if (chunkId === 6) return "./chunk-previewMatchesListVideoSlider.b7c15f94b16136eb8624.js";
	if (chunkId === 4) return "./chunk-headermenuflat.05754f4837051437177d.js";
	if (chunkId === 43) return "./default/info-toggle.d712ae3ee185f8a18eb2.js";
	if (chunkId === 50) return "./default/tabs.b401d97fd716c2780786.js";
	if (chunkId === 10) return "./chunk-sportmodDayResultDatepicker.64d33f0040f564c86985.js";
	if (chunkId === 63) return "./63.e82d0af8e23d53cafc9a.js";
	if (chunkId === 8) return "./chunk-sportmod-live-match-websocket-updater.bc5b421951f6b3cf3775.js";
	if (chunkId === 7) return "./chunk-sportmod-league-phase-reloader.10043d58cbb8ac42bc8c.js";
	if (chunkId === 9) return "./chunk-sportmod-matches-with-table-phase-reloader.e82ad7a8852cd86d7a5c.js";
	// return url for filenames based on template
	return undefined;
};